import { CommonModule } from '@angular/common';
import { Component, Input, Signal, computed, effect } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-progress-bar-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar-modal.component.html',
  styleUrl: './progress-bar-modal.component.scss',
})
export class ProgressBarModalComponent {
  @Input() progressTitle = 'Uploading Attachments...';
  @Input() totalTasks: Signal<number>;
  @Input() progress: Signal<number>;
  @Input() progressText: Signal<string>;

  percentage = computed(() => {
    if (this.totalTasks() === 0) return 0;
    return Math.round((this.progress() / this.totalTasks()) * 100);
  });

  constructor(public activeModal: NgbActiveModal) {
    effect(() => {
      if (this.percentage() === 100) {
        this.closeModal();
      }
    });
  }

  closeModal(): void {
    this.activeModal.close();
  }
}
